import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import ja from "vuetify/src/locale/ja";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    dark: true,
    themes: {
      dark: {
        primary: '#1693A6',
        accent: '#FAC420',
        secondary: '#7DB0C1',
        success: '#639065',
        info: '#518AB7',
        warning: '#C9AB4F',
        error: '#B2747F'
      },
    },
  },
  lang: {
    locales: { ja },
    current: "ja",
  },
});
